import { type HTMLAttributes, type ReactNode, type TableHTMLAttributes } from 'react'
import styles from './DataTable.module.css'

type DataTableSurfaceProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode
  fullWidth?: boolean
  mobileStack?: boolean
  mobileVariant?: 'entityList'
}

type DataTableElementProps = TableHTMLAttributes<HTMLTableElement> & {
  children: ReactNode
}

type DataTableProps = DataTableSurfaceProps & {
  scrollClassName?: string
  tableClassName?: string
}

export const DataTableSurface = ({
  children,
  className,
  fullWidth = false,
  mobileStack = false,
  mobileVariant,
  ...props
}: DataTableSurfaceProps) => (
  <section
    className={[
      styles.surface,
      fullWidth ? 'full-width' : '',
      mobileStack ? styles.mobileStack : '',
      mobileStack ? 'mobile-stack-table' : '',
      mobileVariant === 'entityList' ? styles.entityList : '',
      className
    ].filter(Boolean).join(' ')}
    {...props}
  >
    {children}
  </section>
)

export const DataTableElement = ({
  children,
  className,
  ...props
}: DataTableElementProps) => (
  <table className={[styles.table, 'media-table', className].filter(Boolean).join(' ')} {...props}>
    {children}
  </table>
)

export const DataTable = ({
  children,
  scrollClassName,
  tableClassName,
  ...props
}: DataTableProps) => {
  const table = (
    <DataTableElement className={tableClassName}>
      {children}
    </DataTableElement>
  )

  return (
    <DataTableSurface {...props}>
      {scrollClassName ? <div className={scrollClassName}>{table}</div> : table}
    </DataTableSurface>
  )
}
